module.exports = __webpack_public_path__ + "908e4d2e/img/arrow-left-icon.785c715c.svg";